<template>
  <!-- Blocks the dashboard while the SaaS account is suspended (DESIGN §6.1, §8.3). Bills & payments
       stays reachable (App.vue does not render this overlay there), and the user can sign out. -->
  <div class="suspended-overlay">
    <v-card class="suspended-card rounded-lg" elevation="12">
      <div class="suspended-head text-center px-8 pt-8 pb-4">
        <v-icon size="48" color="error">mdi-lock-alert-outline</v-icon>
        <div class="text-h5 font-weight-bold dark--text mt-3">{{ $t('saasPlan.suspendedTitle') }}</div>
      </div>
      <v-card-text class="text-center px-8">
        <p class="text-body-1 dark--text mb-3">{{ $t('saasPlan.suspendedMessage') }}</p>
        <p v-if="sinceText" class="text-body-2 grey--text text--darken-1 mb-1">{{ $t('saasPlan.suspendedSince', { date: sinceText }) }}</p>
        <p v-if="reasonText" class="text-body-2 grey--text text--darken-1 mb-1">{{ $t('saasPlan.suspendedReason', { reason: reasonText }) }}</p>
        <p class="text-body-2 grey--text text--darken-1 mt-4 mb-0">{{ $t('saasPlan.suspendedBillsHint') }}</p>
      </v-card-text>
      <v-card-actions class="suspended-actions px-8 pb-8">
        <v-btn color="primary" depressed class="text-capitalize" @click="openBills">
          <v-icon left small>mdi-file-document-outline</v-icon>
          {{ $t('bills-and-payments.billsAndPayments') }}
        </v-btn>
        <v-btn outlined color="error" class="text-capitalize" @click="$emit('logout')">
          <v-icon left small>mdi-logout</v-icon>
          {{ $t('core.logout') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "SuspendedOverlay",
  props: {
    // { since, reason } from the SaaS status response; either may be missing
    suspension: {
      type: Object,
      default: null,
    },
  },
  computed: {
    sinceText() {
      const since = this.suspension && this.suspension.since;
      return since && moment(since).isValid() ? moment(since).format("MMM DD, YYYY") : "";
    },
    reasonText() {
      const reason = this.suspension && this.suspension.reason;
      return typeof reason === "string" ? reason.trim() : "";
    },
  },
  methods: {
    openBills() {
      this.$router.push({ name: "BillsAndPayments" }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.suspended-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
}

.suspended-card {
  width: 100%;
  max-width: 560px;
}

.suspended-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

/* the flex gap spaces the buttons; drop Vuetify's own sibling margin so RTL matches LTR */
.suspended-actions > .v-btn + .v-btn {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
